var _metadata, _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKommunresursLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 700,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, "image/svg+xml")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0,612.288l436.538,0l0,-612.288l-436.538,0l0,612.288z",
    id: "path32"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 702,
    width: 902,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(3.1717455059513964,0,0,-2.9187415272824153,-270.0208161380921,998.2492670495086) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2f64ab",
    fillRule: "nonzero",
    d: "m125.357399,220.561203l101.957,-31.277l-40.937,-44.735l-61.02,76.012z",
    id: "path14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4077c4",
    fillRule: "nonzero",
    d: "m91.451698,265.133514l32.542,-41.625l84.708,-25.958l-117.25,67.583z",
    id: "path18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4077c4",
    fillRule: "nonzero",
    d: "m189.265594,144.533905l170.238,185.119l-75.595,-157.738l-94.643,-27.381z",
    id: "path22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30",
    clipPath: "url(#clipPath34)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKommunresursLogoHeader);
export default __webpack_public_path__ + "static/media/kommunresurs-logo-header.a009188af57b8eed851f322c917b4eca.svg";
export { ForwardRef as ReactComponent };